import { render, staticRenderFns } from "./PatientsBlock.vue?vue&type=template&id=171758be"
import script from "./PatientsBlock.vue?vue&type=script&lang=js"
export * from "./PatientsBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports